import React, { useState, useEffect } from 'react';
import { Modal } from 'antd';
import { useLoadTypeContentData } from '../../../../../../Utils/customHooks/UpToDateContent/useLoadTypeContent';
import { ModalBackButton } from '../../../../../../components/EditModalComponents.tsx/ModalBackButton';
import PreviewComponent from '../../ShopLinksComponents/SubListComponents/PreviewComponent';
import { useLocation } from 'react-router-dom';
import '../../../../../../components/CheckboxComponent/FeedCheckboxComponent.css'
import '../../../../../../components/StayUpToDateComponent/StayUpToDate.css'
import track, { TRACKING_TYPES } from '../../../../../../Utils/SupabaseServices/Track';
import { addComponent } from '../../../../../../Utils/SupabaseServices/StayUpToDateDatabase';

interface CommonContentComponentProps {
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
    setIsContentModalOpen: (isOpen: boolean) => void;
    user_id: string;
    username: string;
    refetch: () => void;
    from: string;
    contentType: string;
    platform: string;
    title: string;
}

type ContentConfigType = {
    [key: string]: {
        name: string;
        displayName: string;
        type: string;
    }
};

const CommonContentComponent = (props: CommonContentComponentProps) => {
    const {
        isOpen,
        setIsOpen,
        setIsContentModalOpen,
        user_id,
        username,
        refetch,
        from,
        contentType,
        platform,
        title
    } = props;
    const location = useLocation();
    const [name, setName] = useState(title);
    const [errorMsg, setErrorMsg] = useState('');
    const [confirmLoading, setConfirmLoading] = useState(false);

    // Load content data for preview
    const { isLoading, data: contentData } = useLoadTypeContentData(
        username,
        user_id,
        platform,
        contentType,
        "",
        "DESC"
    );


    const handleOk = async () => {
        try {
            setConfirmLoading(true);

            // Configuration for each content type
            const contentConfig: ContentConfigType = {
                TIKTOK: {
                    name: "Latest TikToks",
                    displayName: "tiktok",
                    type: "tiktok"
                },
                VIDEO: {
                    name: "Latest YouTube Videos",
                    displayName: "youtube",
                    type: "youtube"
                },
                PODCAST: {
                    name: "Latest Podcast Episodes",
                    displayName: "podcast",
                    type: "podcast"
                },
                REELS: {
                    name: "Latest Instagram Reels",
                    displayName: "reels",
                    type: "reels"
                },
                FEATURE: {
                    name: "Featured Content",
                    displayName: "featured",
                    type: "featured"
                },
                TWEET: {
                    name: "Latest X Posts",
                    displayName: "twitter",
                    type: "twitter"
                },
                STORY: {
                    name: "Latest Instagram Stories",
                    displayName: "instagram story",
                    type: "instagram story"
                },
                LINKEDIN: {
                    name: "Latest LinkedIn Posts",
                    displayName: "linkedin",
                    type: "linkedin"
                }
            };

            const config = contentConfig[contentType];
            if (!config) {
                throw new Error(`Invalid content type: ${contentType}`);
            }

            const res = await addComponent(
                config.name,
                "", // details
                username,
                user_id,
                "false", // isDays
                "Check it out!", // cta
                "", // query
                config.displayName, // displayName
                config.type, // type
                "", // postIds
                "DESC", // content_order
                "rect", // content_shape
                false, // content_sound
                undefined, // shoppable_content_filter
                from // from
            );

            if (res === "true") {
                track("Add Content Component", TRACKING_TYPES.EVENT, {
                    pathname: location.pathname,
                    details: { type: contentType, platform: platform },
                    user_id: user_id,
                    title: "Stay Up To Date",
                });
                refetch();
                setIsOpen(false);
                setIsContentModalOpen(false);
                setConfirmLoading(false);
            } else {
                setErrorMsg("Failed to add component");
                setConfirmLoading(false);
            }
        } catch (error) {
            console.error('Error saving content:', error);
            setErrorMsg('Failed to save content');
            setConfirmLoading(false);
        }
    };

    const handleCancel = () => {
        setIsOpen(false);
    };

    const handlePrevious = () => {
        setIsContentModalOpen(true);
        setIsOpen(false);
    };

    return (
        <Modal
            open={isOpen}
            onOk={handleOk}
            onCancel={handleCancel}
            okText="Add"
            confirmLoading={confirmLoading}
            focusTriggerAfterClose={false}
            getContainer={false}
            width={600}
            centered
            className="add-to-page-modal"
            closeIcon={<span className="modal-close-icon">×</span>}
        >
            <ModalBackButton
                handlePrevious={handlePrevious}
                title={`Add ${title}`}
                description={`This carousel automatically displays your 25 most recent ${title}`}
            />

            {errorMsg && <p className="errorMsg text-center">{errorMsg}</p>}

            <div className="mt-4">
                <label className="bold-label fontsize-12">Preview</label>
                <PreviewComponent
                    username={username}
                    user_id={user_id}
                    displayName={title}
                    type="trending products"
                    title={title}
                    data={contentData}
                    isLoading={isLoading}
                />
            </div>
        </Modal>
    );
};

export default CommonContentComponent; 